import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import MobileProductListingFiltersButton from './MobileProductListingFiltersButton';
import MobileProductListingFiltersModal from './MobileProductListingFiltersModal';
const MobileProductListingFiltersButtonAndModal = () => {
  const $ = _c(4);
  const [isMobileFiltersModalOpen, setIsMobileFiltersModalOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MobileProductListingFiltersButton onClick={() => {
      setIsMobileFiltersModalOpen(true);
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsMobileFiltersModalOpen(false);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isMobileFiltersModalOpen) {
    t2 = <>{t0}<MobileProductListingFiltersModal isOpen={isMobileFiltersModalOpen} onClose={t1} /></>;
    $[2] = isMobileFiltersModalOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default MobileProductListingFiltersButtonAndModal;